var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapeSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 1.48148C15.9997 0.663282 15.3364 0 14.5182 0H4.59086C3.77266 0 3.10938 0.663282 3.10938 1.48148V4.73837C4.06059 4.30188 5.10959 4.04989 6.22083 4.04989C10.3857 4.04989 13.7772 7.4833 13.7772 11.6997C13.7772 12.1632 13.7283 12.6087 13.6528 13.0497H14.5182C15.3364 13.0497 15.9997 12.3864 15.9997 11.5682V1.48148Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22291 18.0001C9.65972 18.0001 12.4458 15.1795 12.4458 11.7002C12.4458 8.22092 9.65972 5.40039 6.22291 5.40039C2.78609 5.40039 0 8.22092 0 11.7002C0 15.1795 2.78609 18.0001 6.22291 18.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSmall);
export default __webpack_public_path__ + "static/media/shape-small.1e18c0d89a8c5f2acb05fb17694bc63b.svg";
export { ForwardRef as ReactComponent };